module.exports = __webpack_public_path__ + "media/images/bg_header_pc-1f564bbce95e8808d57770e39d2e9410.jpg";